(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-kh-rules]').forEach((guide) => {
      if (guide.dataset.ready) return;
      guide.dataset.ready = 'true';
      const calculator = guide.querySelector('[data-score-calculator]');
      const selects = [...calculator.querySelectorAll('select')];
      const result = calculator.querySelector('[data-score-result]');
      const error = calculator.querySelector('#score-error');
      const update = () => {
        const teams = ['1', '2'].map((team) => {
          const fields = selects.filter((field) => field.dataset.team === team);
          const [hole, board] = fields.map((field) => Number(field.value));
          const valid = [hole, board].every((n) => Number.isInteger(n) && n >= 0 && n <= 4) && hole + board <= 4;
          fields.forEach((field) => field.setAttribute('aria-invalid', String(!valid)));
          return { valid, score: hole * 3 + board };
        });
        const invalid = teams.some((team) => !team.valid);
        error.hidden = !invalid;
        error.textContent = invalid ? 'Hvert hold har kun fire poser. Vælg højst fire i alt pr. hold.' : '';
        result.hidden = invalid;
        if (invalid) { result.textContent = ''; return; }
        const [a, b] = teams.map((team) => team.score);
        const difference = Math.abs(a - b);
        result.textContent = difference === 0
          ? `${a} mod ${b}. Begge hold får 0 point.`
          : `${a} mod ${b}. Hold ${a > b ? 'A' : 'B'} får ${difference} point. Hold ${a > b ? 'B' : 'A'} får 0.`;
      };
      calculator.addEventListener('change', update);
      calculator.hidden = false;
      update();
      const print = guide.querySelector('[data-rules-print]');
      print.hidden = false;
      print.addEventListener('click', () => window.print());
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
